import { Theme } from "../../../types";
import { CSSObject } from "@emotion/react";

export const clientsAnalyticsOverviewStyles = (
  theme: Theme,
): { [key: string]: Record<string, CSSObject | string | number> } => ({
  summaryText: {
    color: theme.colorSchema.colors.mainText,
    marginBottom: "16px",
    fontFamily: "Gilroy-Regular",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
    gap: "16px",
    width: "100%",
  },
  card: {
    background: "#F6F6F6",
    borderRadius: 8,
    padding: "16px",
    cursor: "pointer",
    transition: "box-shadow 0.15s ease",
    boxSizing: "border-box",
    "&:hover": {
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.10)",
    },
  },
  cardTitle: {
    fontFamily: "Gilroy-SemiBold",
    fontSize: 14,
    color: theme.colorSchema.colors.mainText,
    marginBottom: "8px",
  },
  chartWrap: {
    width: "100%",
    height: 140,
  },
  legendList: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginTop: "8px",
    maxHeight: "160px",
    overflowY: "auto",
  },
  legendRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    fontSize: 12,
  },
  legendLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "6px",
    minWidth: 0,
  },
  legendSwatch: {
    width: 8,
    height: 8,
    borderRadius: 2,
    flexShrink: 0,
  },
  legendLabel: {
    color: theme.colorSchema.colors.mainText,
    opacity: 0.8,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  legendValue: {
    color: theme.colorSchema.colors.mainText,
    fontFamily: "Gilroy-SemiBold",
    flexShrink: 0,
  },
  tooltip: {
    background: "#fff",
    border: "1px solid #E7E6E6",
    borderRadius: 6,
    padding: "6px 10px",
    fontSize: 12,
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
  },
  tooltipLabel: {
    color: theme.colorSchema.colors.mainText,
    opacity: 0.8,
    marginRight: "6px",
  },
  tooltipValue: {
    color: theme.colorSchema.colors.mainText,
    fontFamily: "Gilroy-SemiBold",
  },
  toggleButton: {
    background: "none",
    border: "none",
    padding: 0,
    marginTop: "8px",
    cursor: "pointer",
    color: theme.colorSchema.colors.primary,
    fontFamily: "Gilroy-SemiBold",
    fontSize: 12,
    textAlign: "left",
  },
  backLink: {
    cursor: "pointer",
    color: theme.colorSchema.colors.primary,
    marginBottom: "16px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "Gilroy-SemiBold",
    fontSize: 13,
  },
});
